<template>
  <div ref="container" class="parallax">
    <div ref="transform">
      <slot></slot>
    </div>
  </div>
</template>


<script>
function ease(x) {
  // Easing function for translation
  // https://stackoverflow.com/a/25730573/23714912
  return x; // Linear
  // return x * x * (3 - 2 * x); // Bézier
  // return (x <= .5) ? x : 2 * (x -= .5) * (1 - x) + .5; // Linear until 50% then quadratic
}

function getPct(top, d) {
  if ((document.body.scrollHeight - top) < innerHeight)
    // The top of this element will not have reached the top of the window by the time we scroll to the bottom of the
    // document, so we just scroll it faster
    return (document.body.scrollHeight - scrollY - innerHeight) / (document.body.scrollHeight - top);
  return (top - scrollY - d) / (innerHeight - d);
}

export default {
  name: 'parallax',

  mounted() {
    addEventListener('scroll', this.adjust);
    addEventListener('resize', this.adjust);
    this.adjust();
  },

  beforeDestroy() {
    removeEventListener('scroll', this.adjust);
    removeEventListener('resize', this.adjust);
  },

  methods: {
    adjust() {
      requestAnimationFrame(
        () => {
          const d = 0.15 * innerHeight; // 15vh
          const pct = Math.min(1, Math.max(0, 1 - getPct(this.$refs.container.offsetTop, d)));
          this.$refs.transform.style.transform = `translateY(-${Math.round(d * ease(pct))}px)`;
        }
      );
    }
  }
}
</script>
